export const BUGSNAG_ENABLED_BREADCRUMB_TYPES = ['error', 'navigation', 'request', 'user'];
export const BUGSNAG_METADATA_KEYS = {
    APP_INFO: 'app-info',
};
export const BUGSNAG_REACT_PLUGIN_NAME = 'react';
